module.exports = __webpack_public_path__ + "img/Bild 12 Vitra-Corpform-1 Entry WAZ.546873e4.jpg";